import { getQueryString } from '/src/features/dashboards/design/components/page-filter/url-filters-util';

export const setUserDetails = (state, details) => {
  state.user = details;
  state.Email = null;
  state.Language = null;
};

export const setOtpInfo = (state, { email = null, language = null } = {}) => {
  state.Email = email;
  state.Language = language;
};

export const setClientThemeDetails = (state, theme) => {
  state.theme = theme;
};

export const setPlatformNotificationsList = (state, notifications) => {
  const iconMap = {
    'fas fa-bell': 'notifications',
    'fas fa-cog': 'settings',
    'fas fa-wrench': 'build',
    'fas fa-sync-alt': 'cached'
  };
  const notificationsList = notifications.map((item) => ({
    ...item,
    Icon: iconMap[item.Icon] || item.Icon,
    lastUpdatedAt: item.UpdatedAt || item.CreatedAt,
    lastUpdatedBy: item.lastUpdatedBy || item.CreatedBy
  }));
  // Sort notifications list by last update date in descending order
  notificationsList.sort(
    (previousNotification, nextNotification) =>
      new Date(nextNotification.lastUpdatedAt) - new Date(previousNotification.lastUpdatedAt)
  );
  state.platformNotificationsList = notificationsList;
};

export const setLastCheckedTasks = (state, value) => {
  state.user.LastCheckedTasks = value;
};

export const setQuicklinks = (state, quicklinks) => {
  const quicklinkList = quicklinks.map((quicklink) => ({
    ...quicklink,
    navigateTo: quicklink.URL + getQueryString(JSON.parse(quicklink.FilterJson)),
    lastUpdatedAt: quicklink.UpdatedAt || quicklink.CreatedAt
  }));
  // Sort quicklinks list by last update date in descending order
  quicklinkList.sort((previousQuicklink, nextQuicklink) => previousQuicklink.Name.localeCompare(nextQuicklink.Name));
  state.quicklinks = quicklinkList;
};

export const setQuicklink = (state, quicklink) => {
  const quicklinkList = state.quicklinks.map((item) => ({
    ...(quicklink.UUID === item.UUID ? quicklink : item)
  }));

  state.quicklinks = quicklinkList;
};

export const removeQuicklink = (state, quicklink) => {
  const quicklinkList = state.quicklinks.filter((item) => quicklink.UUID !== item.UUID);
  state.quicklinks = quicklinkList;
};

export const addQuicklink = (state, quicklink) => {
  state.quicklinks = [
    { ...quicklink, navigateTo: quicklink.URL + getQueryString(JSON.parse(quicklink.FilterJson)) }
  ].concat(state.quicklinks);
};
